const hostName = window && window.location && window.location.hostname;

let baseUrl =
  process.env.REACT_APP_PROD_ENV_API ||
  "http://qa-json.tramtracker.com.au/tramTRACKERV2";
let tkn = "dab6a03c-8d79-41df-8fa5-d6882a506cbc";
let nextCollectionAPICall = "GetNextThreePredictedRoutesCollection";
if (
  [
    "venuepids-dev.tramtracker.com.au",
    "venuepids-test.tramtracker.com.au",
    "vpidsdevxuzasestgen-endpoint.azureedge.net",
    "vpidststymfasestgen-endpoint.azureedge.net",
    "localhost",
  ].includes(hostName)
) {
    baseUrl =
        process.env.REACT_APP_DEV_ENV_API ||
        "https://qa-json.tramtracker.com.au/tramTRACKERV2";
    tkn = "8987d306-3598-4534-ba9e-f3fc00c43353";
    nextCollectionAPICall = "GetNextPredictedRoutesCollection";
}
const tramTrackerURL = baseUrl + "/RestService/";
async function queryEndpoint(endpoint, params) {
  const queryString =
    tramTrackerURL +
    endpoint +
    "/" +
    (params ? params.join("/") : "") +
    `/?aid=VenuePID&cid=2&tkn=${tkn}`;
  return fetch(queryString)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then((result) => result.json())
    .then((decodedJson) => {
      return decodedJson.hasResponse ? decodedJson.responseObject : decodedJson;
    });
}

async function queryEndpointWithNoParams(endpoint) {
  const queryString =
    tramTrackerURL +
    endpoint +
        `/?aid=VenuePID&cid=2&tkn=${tkn}`;
    return fetch(queryString)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((result) => result.json())
        .then((decodedJson) => {
            return decodedJson.hasResponse ? decodedJson.responseObject : decodedJson;
        });
}

async function getStopInfo(trackerId) {
  const response = await queryEndpoint("GetStopInformation", [trackerId]);
  return response[0] ? response[0] : response;
}

function getStopPredictions(trackerId, routeNo = 0, lowFloor = false) {
  return queryEndpoint(nextCollectionAPICall, [trackerId, routeNo, lowFloor]).then(
    (routePredictions) => {
      //Use a reducer function to put the returned array into a nice object with readable keys
      const groupedPredictions = routePredictions.reduce((obj, item) => {
        obj[item.RouteNo] = [...(obj[item.RouteNo] || []), item];
        return obj;
        //Remeber to have an empty {} as the starting object or you end up debugging for ages! :)
      }, {});
      return groupedPredictions;
    }
  );
}

function getStopRoutes(trackerId) {
  return queryEndpoint("GetMainRoutesForStop", [trackerId]);
}

function getRouteColours() {
    
    const rcolours = Promise.all([queryEndpointWithNoParams("GetRouteColours")]);
    return Promise.all([
        queryEndpointWithNoParams("GetRouteColours"),
    ]).then(([colours]) => {
        //Flatten the two arrays into a single array, then apply a reducing function
        colours.map((item) => {
            item.PIDColour = '#' + item.PIDColour;
            item.TextColour = '#' + item.TextColour;
        });
        return colours;
    });
  
}

export { getStopInfo, getStopPredictions, getStopRoutes, getRouteColours };
